"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = App;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectSpread5 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _getUtils = _interopRequireDefault(require("wapplr-react/dist/common/Wapp/getUtils"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var _utils = require("wapplr/dist/common/utils");
var _withMaterial = require("common-components/dist/common/components/Template/withMaterial");
var _Template = _interopRequireDefault(require("common-components/dist/common/components/Template"));
var _context2 = _interopRequireDefault(require("common-components/dist/common/components/App/context"));
var _context3 = _interopRequireDefault(require("common-components/dist/common/components/Post/context"));
var _externalContext = _interopRequireDefault(require("common-components/dist/common/components/App/externalContext"));
var _localStorage = require("common-components/dist/common/utils/localStorage");
var _memoStorage = require("common-components/dist/common/utils/memoStorage");
var _messages = _interopRequireDefault(require("../../config/constants/messages"));
var _labels = _interopRequireDefault(require("../../config/constants/labels"));
var _titles = _interopRequireDefault(require("../../config/constants/titles"));
var _routes = _interopRequireDefault(require("../../config/constants/routes"));
var _menus = _interopRequireDefault(require("../../config/constants/menus"));
var _Logo = _interopRequireDefault(require("../Logo"));
var _LogoButton = _interopRequireDefault(require("../Logo/LogoButton"));
var _Artwork = _interopRequireDefault(require("../Artwork"));
var _BlankScreen = _interopRequireDefault(require("../BlankScreen"));
var _utils2 = require("../Artwork/utils");
var _menu = _interopRequireDefault(require("./menu"));
var _topMenu = _interopRequireDefault(require("./topMenu"));
var _getFooterMenu2 = _interopRequireDefault(require("./getFooterMenu"));
var _materialTheme = require("./materialTheme");
var style = require("./style_css.js")["default"];
var runStyle = require("./run_css.js")["default"];
var ThemedTemplate;
function App(props) {
  var _data$settings;
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var externalContext = (0, _react.useContext)(_externalContext["default"]);
  var _externalContext$exte = externalContext.externalSettings,
    externalSettings = _externalContext$exte === void 0 ? {} : _externalContext$exte;
  var postContext = (0, _react.useContext)(_context3["default"]);
  var wapp = context.wapp,
    res = context.res;
  var post = postContext.post;
  if (wapp.globals.DEV && wapp.globals.NAME === wapp.globals.RUN) {}
  var utils = (0, _getUtils["default"])(context);
  var subscribe = props.subscribe,
    Canvas = props.Canvas;
  var heightByParent = externalSettings.heightByParent;
  if (!ThemedTemplate) {
    ThemedTemplate = (0, _withMaterial.withMaterialTheme)({
      theme: _materialTheme.materialTheme,
      mediaQuery: _materialTheme.materialMediaQuery,
      classNamePrefix: 'APP'
    }, _Template["default"]);
  }
  var storageName = externalSettings.id ? wapp.globals.NAME + '_' + externalSettings.id : post !== null && post !== void 0 && post.id ? wapp.globals.NAME + '_' + (post === null || post === void 0 ? void 0 : post.id) : wapp.globals.NAME;
  var storage = function storage(data, memo) {
    if (memo) {
      return (0, _memoStorage.storage)(data ? data : {}, storageName);
    }
    return (0, _localStorage.storage)(data, storageName);
  };
  var template = {};
  var appContext = {
    messages: _messages["default"],
    labels: _labels["default"],
    titles: _titles["default"],
    routes: _routes["default"],
    menus: _menus["default"],
    storage: storage,
    template: template,
    style: style
  };
  var artworkContext = (0, _utils2.createArtworkContext)({
    context: context,
    appContext: appContext,
    postContext: postContext,
    externalContext: externalContext,
    force: true
  });
  var data = artworkContext.data;
  if ((_data$settings = data.settings) !== null && _data$settings !== void 0 && _data$settings.context) {
    Object.keys(data.settings.context).forEach(function (constantsName) {
      if (appContext[constantsName]) {
        Object.keys(data.settings.context[constantsName]).forEach(function (propertyName) {
          appContext[constantsName][propertyName] = data.settings.context[constantsName][propertyName];
        });
      }
    });
  }
  var container = (0, _react.useRef)();
  var menuProps = {
    externalContext: externalContext,
    postContext: postContext,
    artworkContext: artworkContext,
    post: post
  };
  var showArtwork = (post === null || post === void 0 ? void 0 : post._id) && data;
  var menuElement = {};
  var requestPath = res.wappResponse.route.requestPath;
  var artwork = requestPath.startsWith(_routes["default"].artworkRoute) || requestPath.startsWith(_routes["default"].renderRoute) || requestPath.startsWith(_routes["default"].editorRoute);
  var summary = requestPath === "/" || res.wappResponse.route.path === "/:page" && res.wappResponse.route.params.page === "splitscreen" || requestPath.startsWith(_routes["default"].summaryRoute);
  var render = requestPath.startsWith(_routes["default"].renderRoute);
  var description = requestPath === _routes["default"].descriptionRoute;
  var isThereAnEnabledRoute = artwork || summary || render || description;
  var _useState = (0, _react.useState)(utils.getRequestUrl()),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    url = _useState2[0],
    setUrl = _useState2[1];
  var _useState3 = (0, _react.useState)(externalSettings.fullpage ? "fixed" : externalSettings.position ? externalSettings.position : wapp.globals.NAME === wapp.globals.RUN ? "fixed" : "sticky"),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 1),
    position = _useState4[0];
  var _useState5 = (0, _react.useState)(externalSettings.fullpage || externalSettings.fullscreen ? true : wapp.globals.NAME === wapp.globals.RUN),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 1),
    fullPage = _useState6[0];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    fontsLoaded = _useState8[0],
    setFontsLoaded = _useState8[1];
  var artworkActions = {};
  function onLocationChange(_x) {
    return _onLocationChange.apply(this, arguments);
  }
  function _onLocationChange() {
    _onLocationChange = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(newUrl) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (url !== newUrl) {
              setUrl(newUrl);
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _onLocationChange.apply(this, arguments);
  }
  wapp.styles.use(style);
  if (wapp.globals.NAME === wapp.globals.RUN) {
    wapp.styles.use(runStyle);
  }
  (0, _react.useEffect)(function () {
    document.fonts.ready.then(function () {
      setFontsLoaded(true);
    });
  }, []);
  (0, _react.useEffect)(function () {
    var unsub = subscribe.locationChange(onLocationChange);
    return function useUnsubscribe() {
      unsub();
    };
  }, [url]);
  (0, _react.useEffect)(function () {
    wapp.states.stateManager.actions.app = function (_ref) {
      var type = _ref.type,
        name = _ref.name,
        value = _ref.value;
      return {
        type: type || 'SET_APP',
        payload: {
          name: name,
          value: value
        }
      };
    };
    wapp.states.stateManager.reducers.app = function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var action = arguments.length > 1 ? arguments[1] : undefined;
      switch (action.type) {
        case 'SET_APP':
          return (0, _objectSpread5["default"])((0, _objectSpread5["default"])({}, state), {}, (0, _defineProperty2["default"])({}, action.payload.name, action.payload.value && typeof action.payload.value == 'object' ? (0, _utils.copyObject)(action.payload.value) : action.payload.value));
        case 'INS_APP':
          if (typeof action.payload.value === 'object' && action.payload.value && typeof state[action.payload.name] === 'object' && state[action.payload.name]) {
            return (0, _objectSpread5["default"])((0, _objectSpread5["default"])({}, state), {}, (0, _defineProperty2["default"])({}, action.payload.name, (0, _objectSpread5["default"])((0, _objectSpread5["default"])({}, state[action.payload.name]), (0, _utils.copyObject)(action.payload.value))));
          }
          return (0, _objectSpread5["default"])((0, _objectSpread5["default"])({}, state), {}, (0, _defineProperty2["default"])({}, action.payload.name, action.payload.value && typeof action.payload.value == 'object' ? (0, _utils.copyObject)(action.payload.value) : action.payload.value));
        default:
          return state;
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (externalSettings.effect) {
      externalSettings.effect({
        actions: {
          setData: function setData() {
            if (artworkActions.actions.setData) {
              var _artworkActions$actio;
              (_artworkActions$actio = artworkActions.actions).setData.apply(_artworkActions$actio, arguments);
            } else {
              artworkContext.setData.apply(artworkContext, arguments);
            }
          }
        }
      });
    }
    return function () {
      if (externalSettings.effect) {
        externalSettings.effect({
          actions: {
            setData: function setData() {}
          }
        });
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_context2["default"].Provider, {
    value: appContext
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: container,
    className: style.app
  }, /*#__PURE__*/_react["default"].createElement(ThemedTemplate, {
    position: position,
    fullPage: fullPage,
    heightByParent: heightByParent,
    getMenu: render ? function () {
      return null;
    } : function (p) {
      return (0, _menu["default"])((0, _objectSpread5["default"])((0, _objectSpread5["default"])({}, p), menuProps));
    },
    getTopMenu: render ? function () {
      return null;
    } : function (p) {
      return (0, _topMenu["default"])((0, _objectSpread5["default"])((0, _objectSpread5["default"])({}, p), menuProps));
    },
    getFooterMenu: function getFooterMenu(p) {
      return (0, _getFooterMenu2["default"])((0, _objectSpread5["default"])((0, _objectSpread5["default"])({}, p), menuProps));
    },
    menuProps: {
      effect: function effect(_ref2) {
        var actions = _ref2.actions;
        return menuElement.actions = actions;
      }
    },
    topMenuProps: {
      menuProperties: (0, _objectSpread5["default"])({}, menuProps)
    },
    Logo: !externalSettings.disableLogo && !render ? function () {
      return /*#__PURE__*/_react["default"].createElement(_LogoButton["default"], null, /*#__PURE__*/_react["default"].createElement(_Logo["default"], {
        textStyle: {
          height: "20px"
        }
      }));
    } : null,
    FooterLogo: null,
    title: null,
    effect: function effect(p) {
      template.actions = p === null || p === void 0 ? void 0 : p.actions;
    },
    copyright: render ? null : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_LogoButton["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        height: "16px",
        cursor: "pointer"
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        verticalAlign: "text-top"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "inline-block",
        height: "72%"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Logo["default"], null))), /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginLeft: "6px"
      }
    }, "\xA9 ".concat(new Date().getFullYear()))))),
    pageContentNoPadding: typeof externalSettings.pageContentNoPadding !== "undefined" ? externalSettings.pageContentNoPadding : artwork && showArtwork || summary && showArtwork,
    transparentAppBar: typeof externalSettings.transparentAppBar !== "undefined" ? externalSettings.transparentAppBar : artwork && showArtwork || summary && showArtwork,
    hiddenNoStickyAppBar: typeof externalSettings.hiddenNoStickyAppBar !== "undefined" ? externalSettings.hiddenNoStickyAppBar : artwork && showArtwork || summary && showArtwork,
    disableFooter: typeof externalSettings.disableFooter !== "undefined" ? externalSettings.disableFooter : artwork && showArtwork
  }, showArtwork && isThereAnEnabledRoute ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.fontLoader
  }, /*#__PURE__*/_react["default"].createElement("div", null, "Roboto Font 300"), /*#__PURE__*/_react["default"].createElement("div", null, "Roboto Font 400"), /*#__PURE__*/_react["default"].createElement("div", null, "Roboto Font 500"), /*#__PURE__*/_react["default"].createElement("div", null, "Roboto Font 700"), /*#__PURE__*/_react["default"].createElement("div", null, fontsLoaded ? "loaded" : "not loaded")), fontsLoaded ? /*#__PURE__*/_react["default"].createElement(_Artwork["default"], {
    Canvas: Canvas,
    fullPage: fullPage,
    effect: function effect(_ref3) {
      var actions = _ref3.actions;
      artworkActions.actions = actions;
    }
  }) : null) : /*#__PURE__*/_react["default"].createElement(_BlankScreen["default"], null))));
}